<div class="p-(--padding-card)">
  <ces-route-title [count]="models().length">
    <ces-button [label]="'common.buttons.add' | transloco" icon="add" (onClick)="createModel()" />
  </ces-route-title>

  <ces-generic-parent-grid
    (createEntity)="createModel()"
    (deleteEntity)="deleteModel($event)"
    (editEntity)="editModel($event)"
    [dataLoadingCompleted]="dataLoaded()"
    [entities]="models()"
    [entityDefinition]="entityDefinition" />
</div>
